// @systeme: contrat
// Les listes fermées de valeurs utilisées partout (base, API, écrans).
// Elles sont déclarées une seule fois ici, en français, et jamais recopiées.
import { z } from 'zod';
export const TypesElement = ['tache', 'evenement', 'note'];
export const SchemaTypeElement = z.enum(TypesElement);
export const StatutsElement = ['a_faire', 'fait', 'a_preciser', 'annule'];
export const SchemaStatutElement = z.enum(StatutsElement);
export const CategoriesElement = [
    'poubelles',
    'sante',
    'administratif',
    'scolaire',
    'maison',
    'social',
    'courses',
    'travail',
    'finances',
    'autre',
];
export const SchemaCategorieElement = z.enum(CategoriesElement);
export const Visibilites = ['espace', 'prive'];
export const SchemaVisibilite = z.enum(Visibilites);
export const Sensibilites = ['normale', 'sante'];
export const SchemaSensibilite = z.enum(Sensibilites);
export const OriginesElement = [
    'manuel',
    'vocal',
    'texte',
    'photo',
    'recurrence',
    'retroplanning',
];
export const SchemaOrigineElement = z.enum(OriginesElement);
export const RolesMembre = ['titulaire', 'membre', 'invite'];
export const SchemaRoleMembre = z.enum(RolesMembre);
export const RolesFamille = ['enfant', 'conjoint', 'parent', 'proche', 'professionnel'];
export const SchemaRoleFamille = z.enum(RolesFamille);
export const ZonesScolaires = ['A', 'B', 'C', 'corse'];
export const SchemaZoneScolaire = z.enum(ZonesScolaires);
export const ClesPlan = ['essai', 'essentiel', 'complet'];
export const SchemaClePlan = z.enum(ClesPlan);
export const TypesQuota = ['vocaux_mois', 'photos_mois'];
export const SchemaTypeQuota = z.enum(TypesQuota);
export const DroitsPlan = ['documents_photo', 'menus', 'coaching'];
export const SchemaDroitPlan = z.enum(DroitsPlan);
/** Les trois gestes de report, plus le choix libre d'une date. */
export const OptionsReport = ['ce_soir', 'demain_matin', 'samedi', 'date'];
export const SchemaOptionReport = z.enum(OptionsReport);
/** Ce que l'utilisatrice peut nous dire quand quelque chose ne va pas. */
export const TypesRetour = ['insatisfaction', 'suggestion', 'bug', 'contenu_incorrect'];
export const SchemaTypeRetour = z.enum(TypesRetour);
export const CiblesRetour = ['element', 'fiche', 'ecran', 'aucune'];
export const SchemaCibleRetour = z.enum(CiblesRetour);
/** Ce qui revient : tous les jours, toutes les semaines, tous les mois, tous les ans. */
export const FrequencesRecurrence = ['quotidien', 'hebdomadaire', 'mensuel', 'annuel'];
export const SchemaFrequenceRecurrence = z.enum(FrequencesRecurrence);
export const StatutsRappel = ['programme', 'envoye', 'annule'];
export const SchemaStatutRappel = z.enum(StatutsRappel);
export const CanauxRappel = ['push', 'courriel'];
export const SchemaCanalRappel = z.enum(CanauxRappel);
export const TypesCapture = ['audio', 'texte', 'image'];
export const SchemaTypeCapture = z.enum(TypesCapture);
/** « normal » : on répond tout de suite ; « vide_ma_tete » : on range en silence, on montre demain matin. */
export const ModesCapture = ['normal', 'vide_ma_tete'];
export const SchemaModeCapture = z.enum(ModesCapture);
export const StatutsCapture = [
    'en_attente',
    'transcription',
    'analyse',
    'prete',
    'validee',
    'erreur',
];
export const SchemaStatutCapture = z.enum(StatutsCapture);
export const StatutsFiche = ['en_attente', 'validee', 'rejetee'];
export const SchemaStatutFiche = z.enum(StatutsFiche);
/** Ce qui peut manquer à une fiche pour être complète. */
export const ChampsFiche = ['date', 'heure', 'personne', 'titre'];
export const SchemaChampFiche = z.enum(ChampsFiche);
export const FournisseursLlm = ['anthropic', 'mistral', 'openai', 'ollama'];
export const SchemaFournisseurLlm = z.enum(FournisseursLlm);
/** « Ce jalon était-il au bon moment ? » (rétro-planning, lot 3). */
export const AvisJalon = ['trop_tot', 'bien', 'trop_tard'];
export const SchemaAvisJalon = z.enum(AvisJalon);
/** Les listes : les courses (une par foyer, créée d'office), ou une liste libre (rentrée, valise…). */
export const TypesListe = ['courses', 'autre'];
export const SchemaTypeListe = z.enum(TypesListe);
/** Les rayons du magasin, pour trier la liste de courses dans l'ordre du parcours. */
export const Rayons = [
    'fruits_legumes',
    'boulangerie',
    'viande_poisson',
    'cremerie',
    'epicerie',
    'surgeles',
    'boissons',
    'hygiene',
    'entretien',
    'bebe',
    'animaux',
    'autre',
];
export const SchemaRayon = z.enum(Rayons);
/** L'abonnement d'un foyer : à l'essai, actif, impayé, résilié, ou expiré (essai fini sans abonnement). */
export const StatutsAbonnement = ['essai', 'actif', 'impaye', 'resilie', 'expire'];
export const SchemaStatutAbonnement = z.enum(StatutsAbonnement);
/** Les fonctionnalités que l'admin peut éteindre d'un interrupteur, sans déploiement. */
export const Fonctionnalites = [
    'photos',
    'vide_ma_tete',
    'partage_listes',
    'invitations',
    'preparations',
];
export const SchemaFonctionnalite = z.enum(Fonctionnalites);
export const SchemaInterrupteurs = z.partialRecord(SchemaFonctionnalite, z.boolean());
/** Les textes légaux affichés dans l'app. */
export const ClesJuridiques = ['cgu', 'cgv', 'confidentialite'];
export const SchemaCleJuridique = z.enum(ClesJuridiques);
//# sourceMappingURL=enumerations.js.map